import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Button } from 'react-bootstrap';
function API() {
    
    const [value1, setValue1] = useState(0);
    const [value2, setValue2] = useState(0);
  


    const [data, setData] = useState([]);
   
    const [apiValues, setApiValues] = useState({
        Insurance: 0,
        Landing: 0,
        CustomDuty: 0,
        AdditionalCustomDuty: 0,
        RegulatoryDuty: 0,
        SalesTax: 0,
        additionalSalesTax: 0,
        IncomeTax: 0,
        CESS: 0,
        DO: 0,
        PortHandling: 0,
        CustomToken: 0,
        Mise: 0,
        AgencyCharges: 0,
        SalesTaxAgencyCharges: 0,
        Transportation: 0,

        //New Vari

        Qty	:0,
        PerTonRate	:0,
        Containers	:0,
        ContainerWeight	:0,
        HMSRate	:0,
        ShrededRate	:0,
        ExRate	:0,
        HSMRatio	:0,
        ShrededRatio	:0,

        LosttBillet	:0,
        LosttBillet2:0,
        RebarLoss	:0,
        RebarLoss2	:0,
        RebarProcessingCost	:0,
        BilletConversionRate	:0,
        


        
    });
    const [userInput, setUserInput] = useState({
        // numberOfContainers: 10,
        //qtyMT: 269.82,
        HSM:0,
        invoiceValueUSD: 0,
        usdConversionRate: 280.0
    });
    const [calculatedValues, setCalculatedValues] = useState({
        invoiceValuePKR:0,
        importValuePKR:0,
        insurance: 0,
        TotalIns:0,
       
        landing: 0,
        additionalCustomDuty:0,
        regulatoryDuty:0,
        salesTax:0,
        AdditionalSalesTax:0,
        incomeTax:0,
        cess:0,
        salesTaxAgencyCharges:0,
       
        

        totalTaxesAndDuties: 0,
        doCharges: 0,
        portHandlingCharges: 0,
        mise:0,
        agencyCharges:0,
        transportation: 0,
        allCharges:0,
        perTonRate:0,
        shrededRatio:0,
        // ... add other calculated values
    });

    //HSM02
    const [calculatedValues02, setCalculatedValues02] = useState({

        billetCost:0,
        reBarperTCost:0,
            
        invoiceValuePKR:0,
        importValuePKR:0,
        insurance: 0,
        TotalIns:0,
        
        landing: 0,
        additionalCustomDuty:0,
        customDuty:0,
        regulatoryDuty:0,
        salesTax:0,
        AdditionalSalesTax:0,
        incomeTax:0,
        cess:0,
        salesTaxAgencyCharges:0,
       
        

        totalTaxesAndDuties: 0,
        doCharges: 0,
        portHandlingCharges: 0,
        mise:0,
        agencyCharges:0,
        transportation: 0,
        allCharges:0,
        perTonRate:0,
        // ... add other calculated values
    });

    useEffect(() => {
        axios.get('http://175.107.239.227:90/api/tblLCCostingParameters')
        //axios.get('https://localhost:44309/api/tblLCCostingParameters')
            .then(response => {
                if (response.data.length > 0) {
                    console.log('API Values:', response.data[0]);
                    setApiValues(response.data[0]);
                } else {
                    console.error('Empty array in API response');
                }
            })
            .catch(error => {
                console.error('Error fetching API values:', error);
            });
    }, []);

    const formatNumber = (number) => {
        return number.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setUserInput(prevState => ({
    //         ...prevState,
    //         [name]: parseFloat(value) || 0
    //     }));
    // };
 
    const handleCalculate = () => {
       
        const {
            numberOfContainers,
            qtyMT,
            invoiceValueUSD,
            usdConversionRate
        } = userInput;
       
        console.log("val invoiceValueUSD",invoiceValueUSD);
        const invoiceValuePKR =(invoiceValueUSD * apiValues.Qty)*usdConversionRate;
        //console.log('Invoice Value PKR:', invoiceValuePKR);

        if ('Insurance' in apiValues) {
            const insurance = (invoiceValuePKR * apiValues.Insurance) / 100;
           // console.log('Insurance Value PKR:', insurance);
        } else {
            console.error('Insurance property not found in apiValues');
        }

        const insurance = (invoiceValuePKR * apiValues.Insurance) / 100;
        const TotalIns=insurance+invoiceValuePKR;
       // console.log('insurance Value PKR:', insurance);

        let landing = ((invoiceValuePKR+insurance) *( apiValues.Landing)) / 100;
        const importValuePKR = invoiceValuePKR + insurance + landing;
        
        const additionalCustomDuty = (importValuePKR * apiValues.AdditionalCustomDuty) / 100;
        const regulatoryDuty = (importValuePKR * apiValues.RegulatoryDuty) / 100;
        const salesTax = ((importValuePKR +additionalCustomDuty+regulatoryDuty)* (apiValues.SalesTax)) / 100;
        const additionalSalesTax=(importValuePKR * apiValues.AdditionalSalesTax) / 100;
        const incomeTax = ((importValuePKR+ additionalCustomDuty+regulatoryDuty+salesTax+additionalSalesTax)*( apiValues.IncomeTax)) / 100;
        const cess = (importValuePKR * apiValues.CESS) / 100;
         
        const totalTaxesAndDuties = additionalCustomDuty + regulatoryDuty + salesTax + incomeTax + cess;
       // console.log('totalTaxesAndDuties Value PKR:', totalTaxesAndDuties);
        const doCharges = (importValuePKR * apiValues.DO) / 100;
        const portHandlingCharges = (importValuePKR * apiValues.PortHandling) / 100;
        const mise= apiValues.Qty*apiValues.Mise;
        const agencyCharges= apiValues.Containers*apiValues.AgencyCharges;
        const salesTaxAgencyCharges=(agencyCharges*apiValues.SalesTaxAgencyCharges)/100;
        const transportation=apiValues.Qty*apiValues.Transportation;
        const allCharges=totalTaxesAndDuties+importValuePKR+doCharges+portHandlingCharges+mise+agencyCharges+salesTaxAgencyCharges+transportation+apiValues.CustomToken;
        const perTonRate=(additionalCustomDuty + regulatoryDuty +  cess+importValuePKR+doCharges+portHandlingCharges+mise+agencyCharges+transportation+apiValues.CustomToken)/apiValues.Qty;
        const ShrededRatio=(perTonRate*apiValues.ShrededRatio)/100;
       // console.log('ShrededRatio :', ShrededRatio);

        const result = ShrededRatio; // Replace with your actual calculation
    setValue1(result);
        
        // ... other calculations
        //console.log('Calculated result1:', result);
        setCalculatedValues({
            invoiceValuePKR,
            importValuePKR,
            insurance,
            TotalIns,
           
            landing,
            additionalCustomDuty,
            regulatoryDuty,
            salesTax,
        additionalSalesTax,
        incomeTax,
        cess,
    
            totalTaxesAndDuties,
            doCharges,
            portHandlingCharges,
            mise,
            agencyCharges,
            salesTaxAgencyCharges,
            transportation,
            allCharges,
            perTonRate,
            
            // ... other calculated values
        });
       
    };

    //HSM02
    const handleCalculate02 = () => {
        
        const {
            numberOfContainers,
            qtyMT,
            HSM,
            invoiceValueUSD,
            usdConversionRate
        } = userInput;
        

        const invoiceValuePKR =(HSM * apiValues.Qty)*usdConversionRate;
        console.log('HSM:', HSM);

        if ('Insurance' in apiValues) {
            const insurance = (invoiceValuePKR * apiValues.Insurance) / 100;
           // console.log('Insurance Value PKR:', insurance);
        } else {
           // console.error('Insurance property not found in apiValues');
        }

        const insurance = (invoiceValuePKR * apiValues.Insurance) / 100;
        const TotalIns=insurance+invoiceValuePKR;
        //console.log('insurance Value PKR:', insurance);

        let landing = ((invoiceValuePKR+insurance) *( apiValues.Landing)) / 100;
        const importValuePKR = invoiceValuePKR + insurance + landing;
        //console.log('importValuePKR Value PKR:', importValuePKR);
        const additionalCustomDuty = (importValuePKR * apiValues.AdditionalCustomDuty) / 100;
        const customDuty = (importValuePKR * apiValues.CustomDuty) / 100;
        //console.log('customDuty Value PKR:', customDuty);
        const regulatoryDuty = (importValuePKR * apiValues.RegulatoryDuty) / 100;
        const salesTax = ((importValuePKR +additionalCustomDuty+regulatoryDuty+customDuty)* (apiValues.SalesTax)) / 100;
        const additionalSalesTax=(importValuePKR * apiValues.AdditionalSalesTax) / 100;
        
        const incomeTax = ((importValuePKR+ additionalCustomDuty+regulatoryDuty+salesTax+additionalSalesTax+customDuty)*( apiValues.IncomeTax)) / 100;
        const cess = (importValuePKR * apiValues.CESS) / 100;
         
        const totalTaxesAndDuties = additionalCustomDuty + regulatoryDuty + salesTax + incomeTax + cess+customDuty;
        
        const doCharges = (importValuePKR * apiValues.DO) / 100;
        const portHandlingCharges = (importValuePKR * apiValues.PortHandling) / 100;
        const mise= apiValues.Qty*apiValues.Mise;
        const agencyCharges= apiValues.Containers*apiValues.AgencyCharges;
        const salesTaxAgencyCharges=(agencyCharges*apiValues.SalesTaxAgencyCharges)/100;
        const transportation=apiValues.Qty*apiValues.Transportation;
        const allCharges=totalTaxesAndDuties+importValuePKR+doCharges+portHandlingCharges+mise+agencyCharges+salesTaxAgencyCharges+transportation+apiValues.CustomToken;
        const perTonRate=(additionalCustomDuty + regulatoryDuty +  cess+importValuePKR+doCharges+portHandlingCharges+mise+agencyCharges+transportation+apiValues.CustomToken+customDuty)/apiValues.Qty;
        const HSMRatio=(perTonRate*apiValues.HSMRatio)/100;
        const result = HSMRatio; // Replace with your actual calculation
        setValue2(result);
        
       

        const billetLoss=(value1+value2)/apiValues.LosttBillet;
        console.log("billetLoss1",billetLoss);
        const OneP=1-apiValues.LosttBillet2;
        console.log("OneP",OneP);
        const normalLostBillet=((value1+value2))/OneP
        const OnePLostBillet=normalLostBillet/0.99*0.01;
        const Material_cost_after_losses=normalLostBillet+OnePLostBillet;
         console.log("Material_cost_after_losses",Material_cost_after_losses);
         const processing_cost=(apiValues.BilletConversionRate+apiValues.RebarProcessingCost)/apiValues.LosttBillet*apiValues.LosttBillet2;
         console.log("processing_cost",processing_cost);
         
         const billetCost=billetLoss+apiValues.BilletConversionRate;
         console.log("billetCost",billetCost);

         const lostRebar=billetCost/0.99*0.01;
         console.log("lostRebar",lostRebar);
         const reBarCost=apiValues.RebarProcessingCost;
         //console.log("reBarCost",reBarCost);
         //const reBarperTCost= 15692.59519 +billetCost;
         const reBarperTCost= 11000+billetCost/0.99;
         //const reBarperTCost=reBarCost+lostRebar+billetCost;
         console.log("reBarperTonCost",reBarperTCost);
        

        // ... other calculations
        //console.log(' h1 result:', result);
        setCalculatedValues02({
            billetCost,
            reBarperTCost,

            invoiceValuePKR,
            importValuePKR,
            insurance,
            TotalIns,
           
            landing,
            additionalCustomDuty,
            customDuty,
            regulatoryDuty,
            salesTax,
        additionalSalesTax,
        incomeTax,
        cess,
    
            totalTaxesAndDuties,
            doCharges,
            portHandlingCharges,
            mise,
            agencyCharges,
            salesTaxAgencyCharges,
            transportation,
            allCharges,
            perTonRate,
            // ... other calculated values
        });
        //resetInputs();

        
    };


    
      useEffect(() => {
        // This useEffect will be triggered after value1 changes
        handleCalculate02  (); 
       
      }, [value1]);
    const resetInputs= () =>
   {
    handleCalculate  (); 
    handleCalculate02  (); 
   

    
   }

   const [records, setRecords] = useState([]);
   const handleSubmit = (e) => {
     
     };
    return (
        <div className='container'>

            <div>
            
            </div>
            <div className='row'>
<div className='col-sm-4'>

</div>
<div className='col-sm-4'>
<h2>Costing Parameters </h2>
            <form onSubmit={(e) => handleSubmit(e)} >
            {/* <div >

            <label className='form-label'>
            Number of Containers:
                </label>
                <input
                        type="number"
                        name="numberOfContainers"
                        value={apiValues.Containers}
                        onChange={handleInputChange} className="form-control" readOnly
                    />
                 
                </div>
                */}
                   
          
                {/* <label className='form-lable'>
                    Qty (MT):
                    </label>
                    <input
                        type="number"
                        name="qtyMT"
                        value={apiValues.Qty}
                        onChange={handleInputChange} className="form-control" readOnly
                    />
                */}
          
                <label>
                Shredded Rate per ton $ :
                    </label>
                    <input
                       
                        name="invoiceValueUSD"
                        
                        onChange={(e) =>
                            setUserInput({ ...userInput, invoiceValueUSD: e.target.value })
                          } className="form-control"
                    />
                
                <label>
                HSM Rate per ton $ :
                    </label>
                    <input
                       
                        name="HSM"
                        value={userInput.HSM}
                        onChange={(e) =>
                            setUserInput({ ...userInput, HSM: e.target.value })
                          } className="form-control"
                    />
                
            
                <label>
                    
                    Exchange  Rate:
                    </label>
                    <input
  name="usdConversionRate"
  value={userInput.usdConversionRate}
  onChange={(e) =>
    setUserInput({ ...userInput, usdConversionRate: parseFloat(e.target.value) || 0 })
  }
  className="form-control"
/>
                
            </form>
<br></br>

            <Button onClick={  resetInputs }>Calculate</Button> 
            {/* <label className='btn btn-outline-danger' >
            {formatNumber(calculatedValues.perTonRate)}
            </label>
            <label className='btn btn-outline-danger' >
            {formatNumber(calculatedValues02.perTonRate)}
            </label> */}
            <br></br>
            <br></br>
           
   
          
          

            <table className='table table-striped table-hover table-bordered' >
            <tbody>
                <tr>
                    <td>
                    Shredded cost per Ton 
                    </td>
                    <td>
                   
                    </td>
                    <td>
                    {formatNumber(calculatedValues.perTonRate)}
                    </td>
                   </tr>

                   <tr>
                    <td>
                    HMS cost per Ton 
                    </td>
                    <td>
                   
                    </td>
                    <td>
                    {formatNumber(calculatedValues02.perTonRate)}
                    </td>
                   </tr>

                   <tr>
                    <td>
                    Billet cost per Ton

                    </td>
                    <td>
                   
                    </td>
                    <td>
                    {formatNumber(calculatedValues02.billetCost)}
                    </td>
                   </tr>

                   <tr>
                    <td>
                    Rebar cost per Ton

                    </td>
                    <td>
                   
                    </td>
                    <td>
                    {formatNumber(calculatedValues02.reBarperTCost)}
                    </td>
                   </tr>
                   

</tbody>
            </table>

{/* <h2>Hunza Steel Pvt Ltd.</h2> */}
<p>
<ul  >
  <li> Processing cost of {formatNumber(apiValues.BilletConversionRate+apiValues.RebarProcessingCost)}/M Ton  Rebar.</li>
  <li > Depreciation is added back in this figure.</li>
  <li> This cost is based upon production & sales of approx. 12,000 M Ton</li>
  <li >This cost doesn't include any adjustable taxes i.e. sales tax, income tax etc</li>
 
</ul>
</p>


                   
                      
                   
                   

                  
                   .
                 
                    
                  
               {/*    <tr>
                    <td>
                    Invoice Value in PK (Rs.) 
                    </td>
                    <td>
                   
                    </td>
                    <td>
                    {formatNumber(calculatedValues.invoiceValuePKR)}
                    </td>
                   </tr>


                   <tr>
                    <td>
                    Insurance 
                    </td>
                    <td>
                    {apiValues.Insurance}
                    </td>
                    <td>
                    {formatNumber(calculatedValues.insurance)}
                    </td>
                   </tr>
                   <tr>
                    <td>
                     
                    </td>
                    <td>
                   
                    </td>
                    <td>
                    {formatNumber(calculatedValues.TotalIns)}
                    </td>
                   </tr>

                   <tr>
                    <td>
                    Landing 
                    </td>
                    <td>
                    {apiValues.Landing}
                    </td>
                    <td>
                    {formatNumber(calculatedValues.landing)}
                    </td>
                   </tr>
                   <tr>
                    <td>
                    Import Value
                    </td>
                    <td>
                   
                    </td>
                    <td>
                    {formatNumber(calculatedValues.importValuePKR)}
                    </td>
                   </tr>
                   <tr>
                    <td>
                    Custom Duty
                    </td>
                    <td>
                    {apiValues.CustomDuty}
                    </td>
                    <td>
                    {(calculatedValues.CustomDuty)}
                    </td>
                   </tr>
                   <tr>
                    <td>
                    Additional Custom Duty
                    </td>
                    <td>
                    {apiValues.AdditionalCustomDuty}
                    </td>
                    <td>
                    {formatNumber(calculatedValues.additionalCustomDuty)}
                    </td>
                   </tr>
                   <tr>
                    <td>
                   Regulatory Duty
                    </td>
                    <td>
                    {apiValues.RegulatoryDuty}
                    </td>
                    <td>
                    {formatNumber(calculatedValues.regulatoryDuty)}
                    </td>
                   </tr>
                   <tr>
                    <td>
                   Sales Tax
                    </td>
                    <td>
                    {apiValues.SalesTax}
                    </td>
                    <td>
                    {formatNumber(calculatedValues.salesTax)}
                    </td>
                   </tr>

                   <tr>
                    <td>
                   Additional Sales Tax
                    </td>
                    <td>
                    {apiValues.AdditionalSalesTax}
                    </td>
                    <td>
                    {(calculatedValues.additionalSalesTax)}
                    </td>
                   </tr>
                   <tr>
                    <td>
                   Income Tax
                    </td>
                    <td>
                    {apiValues.IncomeTax}
                    </td>
                    <td>
                    {formatNumber(calculatedValues.incomeTax)}
                    </td>
                   </tr>

                   <tr>
                    <td>
                 CESS
                    </td>
                    <td>
                    {apiValues.CESS}
                    </td>
                    <td>
                    {formatNumber(calculatedValues.cess)}
                    </td>
                   </tr>

                   <tr>
                    <td>
                 do Charges
                    </td>
                    <td>
                    {apiValues.DO}
                    </td>
                    <td>
                    {formatNumber(calculatedValues.doCharges)}
                    </td>
                   </tr>

                   <tr>
                    <td>
                 port Handling Charges
                    </td>
                    <td>
                    {apiValues.PortHandling}
                    </td>
                    <td>
                    {formatNumber(calculatedValues.portHandlingCharges)}
                    </td>
                   </tr>
                   <tr>
                    <td>
                 Custom Token
                    </td>
                    <td>
                    {apiValues.CustomToken}
                    </td>
                    <td>
                    {apiValues.CustomToken}
                    </td>
                   </tr>

                   <tr>
                    <td>
                    Misc and handling charges (60 per ton)
                    </td>
                    <td>
                    {apiValues.Mise}
                    </td>
                    <td>
                    {formatNumber(calculatedValues.mise)}
                    </td>
                   </tr>
                   <tr>
                    <td>
                    Agency charges (500 per container)
                    </td>
                    <td>
                    {apiValues.AgencyCharges}
                    </td>
                    <td>
                    {calculatedValues.agencyCharges}
                    </td>
                   </tr>
                   <tr>
                    <td>
                    Sales tax on agency charges
                    </td>
                    <td>
                    {apiValues.SalesTaxAgencyCharges}
                    </td>
                    <td>
                    {calculatedValues.salesTaxAgencyCharges}
                    </td>
                   </tr>

                   <tr>
                    <td>
                    Transportation cost
                    </td>
                    <td>
                    {apiValues.Transportation}
                    </td>
                    <td>
                    {calculatedValues.transportation}
                    </td>
                   </tr>
                   <tr>
                    <td>
                    Total cost
                    </td>
                    <td>
                  
                    </td>
                    <td>
                    {formatNumber(calculatedValues02.allCharges)}
                    </td>
                   </tr>
                   


                </tbody>
            </table> */}

</div>
            </div>
           <div >

           </div>
           

           
            {/* <h2>User Input</h2>
            <form>
                <label>
                    Number of Containers:
                    <input
                        type="number"
                        name="numberOfContainers"
                        value={userInput.numberOfContainers}
                        onChange={handleInputChange}
                    />
                </label>
                <br />
                <label>
                    Qty (MT):
                    <input
                        type="number"
                        name="qtyMT"
                        value={userInput.qtyMT}
                        onChange={handleInputChange}
                    />
                </label>
                <br />
                <label>
                    Invoice Value in USD:
                    <input
                        type="number"
                        name="invoiceValueUSD"
                        value={userInput.invoiceValueUSD}
                        onChange={handleInputChange}
                    />
                </label>
                <br />
                <label>
                    USD Conversion Rate:
                    <input
                        type="number"
                        name="usdConversionRate"
                        value={userInput.usdConversionRate}
                        onChange={handleInputChange}
                    />
                </label>
            </form>

            <Button onClick={handleCalculate}>Calculate</Button> */}

            </div>
    );
}

export default API;
